// @ts-nocheck
import {
    chain,
    PopulateApiParameter as basePopulateApiParameter,
} from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import constants from "@store/constants";
import { createChainHandler, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

export const PopulateApiParameter = createChainHandler("PopulateApiParameter", chain, props => {
    basePopulateApiParameter(props as any);
    props.apiParameter.additionalExpands = ["cartLines"];
    const pageType = getCurrentPage(props.getState()).type;
    if (pageType === constants.pageType.checkoutReviewAndSubmit || pageType === constants.pageType.checkoutShipping) {
        props.apiParameter.additionalExpands.push("partrunner");
    }
});

replaceInChain(chain, basePopulateApiParameter, PopulateApiParameter);
